import "./style.less";
// eslint-disable-next-line no-unused-vars
import calenderWeeks from "./assets/icon-weeks.svg";
// eslint-disable-next-line no-unused-vars
import calenderWeek from "./assets/icon-week.svg";
// eslint-disable-next-line no-unused-vars
import calenderDay from "./assets/icon-day.svg";

export default function FilterBarFixed() {
    return {
        restrict: "E",
        scope: {
            activity: "<",
            location: "<",
            weeks: "=",
            callback: "=",
        },
        template: require("./template.html"),

        controller: function ($scope, WeekOptionsModel, UrlFactory) {
            const weekOptions = ($scope.weekOptions = WeekOptionsModel);

            const findWeekOption = (number) => {
                return weekOptions.find((option) => number == option.weeks);
            };

            $scope.weekOption = findWeekOption($scope.weeks);

            $scope.goClassic = function () {
                const params = UrlFactory.getParamsFromUrl();

                UrlFactory.getCollection(
                    params.activityName,
                    params.locationName,
                    params.date,
                    params.start,
                    params.end,
                    params.hours
                ).then((res) => {
                    UrlFactory.setRoute(
                        res.activity,
                        res.location,
                        res.date,
                        res.start,
                        res.end,
                        res.hours
                    );
                });
            };

            $scope.changeWeekOption = (option) => {
                // call api and rerender  search
                $scope.weekOption = option;

                $scope.weeks = option.weeks;

                $scope.callback({ weeks: option.weeks });
            };
        },
    };
}
